import axios from 'axios';

const BASE = `${window.env.API_URL}/api/v1/chat`;
const TIMEOUT = 15_000;

export interface SendResponse {
  reply: string;
  sessionId: string;
  tokenCount: number;
  escalated: boolean;
}

export interface ApiMessage {
  role: 'user' | 'assistant';
  content: string;
  createdAt: string;
}

export interface ConversationResponse {
  sessionId: string;
  messages: ApiMessage[];
  escalated: boolean;
}

/** Normalise GET /chat/:id response — one-place fix if shape ever changes */
function normalize(raw: unknown): ConversationResponse {
  const d = raw as Record<string, unknown>;
  return {
    sessionId: String(d.sessionId ?? ''),
    escalated: Boolean(d.escalated),
    messages: (Array.isArray(d.messages) ? d.messages : []).map((m) => {
      const msg = m as Record<string, unknown>;
      return {
        role: msg.role === 'user' ? ('user' as const) : ('assistant' as const),
        content: String(msg.content ?? ''),
        createdAt: String(msg.createdAt ?? new Date().toISOString()),
      };
    }),
  };
}

export async function sendMessage(
  message: string,
  sessionId?: string,
): Promise<SendResponse> {
  const body: Record<string, string> = { message };
  if (sessionId) body.sessionId = sessionId;
  const { data } = await axios.post<SendResponse>(BASE, body, { timeout: TIMEOUT });
  return data;
}

/** Used only for resync/recovery — not needed in normal operation */
export async function getConversation(sessionId: string): Promise<ConversationResponse> {
  const { data } = await axios.get(`${BASE}/${sessionId}`, { timeout: TIMEOUT });
  return normalize(data);
}
